import {
  VOID3gxj6tk5isa35 as VOID,
  Unit_instance3vdlo4e4f5ggx as Unit_instance,
  getKClass3t8tygqu4lcxf as getKClass,
  arrayOf1akklvh2at202 as arrayOf,
  createKType31ecntyyaay3k as createKType,
  toString1pkumu07cwy4m as toString,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  constructCallableReference23y65rf941mch as constructCallableReference,
  PrimitiveClasses_getInstance143761yrsca9q as PrimitiveClasses_getInstance,
  createInvariantKTypeProjection3h5364czc0a8w as createInvariantKTypeProjection,
  Unitkvevlwgzwiuc as Unit,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Plugin_getInstance2t18sf8ddmzc5 as Plugin_getInstance,
  createClientPluginjwpvufjows5r as createClientPlugin,
  pluginOrNulleoo3166jvfvu as pluginOrNull,
  webSocketSession13aod734non7u as webSocketSession,
} from './ktor-ktor-client-core.mjs';
import {
  Client11cfsk9efm91u as Client,
  rpcClientConfigy5q3ofzedgjx as rpcClientConfig,
} from './kotlinx-rpc-krpc-krpc-core.mjs';
import {
  TypeInfo2nbxsuf4v8os2 as TypeInfo,
  AttributeKey3aq8ytwgx54f7 as AttributeKey,
} from './ktor-ktor-utils.mjs';
import { KrpcClient30gq6xrrg2pfu as KrpcClient } from './kotlinx-rpc-krpc-krpc-client.mjs';
import { CompletableDeferred2lnqvsbvx74d3 as CompletableDeferred } from './kotlinx-coroutines-core.mjs';
import { KtorTransporty9yzfrgq92as as KtorTransport } from './kotlinx-rpc-krpc-krpc-ktor-krpc-ktor-core.mjs';
//region block: imports
//endregion
//region block: pre-declaration
class KtorRpcClient extends KrpcClient {}
class KtorKrpcClientImpl extends KtorRpcClient {
  constructor(pluginConfigBuilder, webSocketSessionFactory) {
    super();
    this.b92_1 = pluginConfigBuilder;
    this.c92_1 = webSocketSessionFactory;
    var tmp = this;
    tmp.d92_1 = KtorKrpcClientImpl$requestConfigBuilder$lambda;
    this.e92_1 = CompletableDeferred();
    this.f92_1 = this.e92_1;
  }
  k91() {
    return this.f92_1;
  }
  *j8z($completion) {
    var session = yield* this.c92_1(KtorKrpcClientImpl$initializeTransport$lambda(this), $completion);
    this.e92_1.l1t(session);
    return new KtorTransport(session);
  }
  b90() {
    var tmp0_safe_receiver = this.b92_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.apply' call
      this.d92_1(tmp0_safe_receiver);
      tmp = tmp0_safe_receiver;
    }
    var tmp1_safe_receiver = tmp;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.j7e();
    return tmp2_elvis_lhs == null ? rpcClientConfig(this.d92_1) : tmp2_elvis_lhs;
  }
}
//endregion
function get_KrpcClientPluginAttributesKey() {
  _init_properties_Krpc_kt__jgh83e();
  return KrpcClientPluginAttributesKey;
}
var KrpcClientPluginAttributesKey;
function get_Krpc() {
  _init_properties_Krpc_kt__jgh83e();
  return Krpc;
}
var Krpc;
function installKrpc(_this__u8e3s4, configure) {
  var tmp;
  if (configure === VOID) {
    tmp = installKrpc$lambda;
  } else {
    tmp = configure;
  }
  configure = tmp;
  _init_properties_Krpc_kt__jgh83e();
  _this__u8e3s4.l85(Plugin_getInstance());
  _this__u8e3s4.e86(get_Krpc(), configure);
}
function Krpc$lambda() {
  _init_properties_Krpc_kt__jgh83e();
  return new Client();
}
function Krpc$lambda_0($this$createClientPlugin) {
  _init_properties_Krpc_kt__jgh83e();
  $this$createClientPlugin.s8a_1.k84_1.j7a(get_KrpcClientPluginAttributesKey(), $this$createClientPlugin.t8a_1);
  return Unit_instance;
}
function installKrpc$lambda(_this__u8e3s4) {
  _init_properties_Krpc_kt__jgh83e();
  return Unit_instance;
}
var properties_initialized_Krpc_kt_4guc9o;
function _init_properties_Krpc_kt__jgh83e() {
  if (!properties_initialized_Krpc_kt_4guc9o) {
    properties_initialized_Krpc_kt_4guc9o = true;
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'KrpcClientPluginAttributesKey';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp = getKClass(Client);
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_0;
    try {
      tmp_0 = createKType(getKClass(Client), arrayOf([]), false);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    var tmp$ret$2 = tmp_0;
    var tmp$ret$1 = new TypeInfo(tmp, tmp$ret$2);
    KrpcClientPluginAttributesKey = new AttributeKey(name, tmp$ret$1);
    var tmp_2 = Krpc$lambda;
    Krpc = createClientPlugin('Krpc', tmp_2, Krpc$lambda_0);
  }
}
function get_KrpcRequestConfigAttributeKey() {
  _init_properties_KtorClientDsl_kt__5fkqms();
  return KrpcRequestConfigAttributeKey;
}
var KrpcRequestConfigAttributeKey;
function rpc(_this__u8e3s4, block) {
  var tmp;
  if (block === VOID) {
    tmp = rpc$lambda;
  } else {
    tmp = block;
  }
  block = tmp;
  _init_properties_KtorClientDsl_kt__5fkqms();
  if (pluginOrNull(_this__u8e3s4, Plugin_getInstance()) == null) {
    // Inline function 'kotlin.error' call
    var message = 'RPC for client requires ' + toString(Plugin_getInstance()) + ' plugin to be installed firstly';
    throw IllegalStateException.o(toString(message));
  }
  var pluginConfigBuilder = _this__u8e3s4.k84_1.h7a(get_KrpcClientPluginAttributesKey());
  return new KtorKrpcClientImpl(pluginConfigBuilder, rpc$slambda(_this__u8e3s4, block));
}
function rpcConfig(_this__u8e3s4, configBuilder) {
  var tmp;
  if (configBuilder === VOID) {
    tmp = rpcConfig$lambda;
  } else {
    tmp = configBuilder;
  }
  configBuilder = tmp;
  _init_properties_KtorClientDsl_kt__5fkqms();
  _this__u8e3s4.a86_1.j7a(get_KrpcRequestConfigAttributeKey(), configBuilder);
}
function rpc$lambda(_this__u8e3s4) {
  _init_properties_KtorClientDsl_kt__5fkqms();
  return Unit_instance;
}
function rpc$slambda$lambda($block, $configSetter) {
  return ($this$webSocketSession) => {
    $block($this$webSocketSession);
    var tmp0_safe_receiver = $this$webSocketSession.a86_1.h7a(get_KrpcRequestConfigAttributeKey());
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      $configSetter(tmp0_safe_receiver);
    }
    return Unit_instance;
  };
}
function rpc$slambda($this_rpc, $block) {
  return constructCallableReference(function *(configSetter, $completion) {
    return yield* webSocketSession($this_rpc, rpc$slambda$lambda($block, configSetter), $completion);
  }, 1);
}
function rpcConfig$lambda(_this__u8e3s4) {
  _init_properties_KtorClientDsl_kt__5fkqms();
  return Unit_instance;
}
var properties_initialized_KtorClientDsl_kt_w0k4wa;
function _init_properties_KtorClientDsl_kt__5fkqms() {
  if (!properties_initialized_KtorClientDsl_kt_w0k4wa) {
    properties_initialized_KtorClientDsl_kt_w0k4wa = true;
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'KrpcRequestConfigAttributeKey';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp = PrimitiveClasses_getInstance().functionClass(1);
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_0;
    try {
      tmp_0 = createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Client), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    var tmp$ret$2 = tmp_0;
    var tmp$ret$1 = new TypeInfo(tmp, tmp$ret$2);
    KrpcRequestConfigAttributeKey = new AttributeKey(name, tmp$ret$1);
  }
}
function KtorKrpcClientImpl$requestConfigBuilder$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function KtorKrpcClientImpl$initializeTransport$lambda(this$0) {
  return (it) => {
    this$0.d92_1 = it;
    return Unit_instance;
  };
}
//region block: post-declaration
initMetadataForClass(KtorRpcClient, 'KtorRpcClient', VOID, VOID, VOID, [0, 1]);
initMetadataForClass(KtorKrpcClientImpl, 'KtorKrpcClientImpl', VOID, VOID, VOID, [0, 1]);
//endregion
//region block: exports
export {
  installKrpc as installKrpcntft8lhf4nye,
  rpcConfig as rpcConfig1aw6avpp4z7tw,
  rpc as rpc16ebqkyzshzc4,
};
//endregion
